/**
 * Created by sxp23 on 2/1/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './../app-routing.module';
import { CommonService} from './../common.service'
import { HeaderModule } from './../header/header.module'
import { LocationModule } from './../location/location.module'
import { HomeComponent} from './home.component'

@NgModule({
  declarations: [HomeComponent],
  imports: [BrowserModule,CommonModule, AppRoutingModule, FormsModule, HeaderModule,LocationModule,NgbModule],
  providers: [CommonService],
  exports: []
})

export class HomeModule { }
